import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Toont het bezorgblok van de geselecteerde variant.
 * Alle varianten worden server-side gerenderd; hier tonen we alleen de actieve.
 * Het retourblok staat op productniveau en blijft altijd staan (buiten deze selector).
 *
 * @extends Component
 */
export class BezorgRetour extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    this.#initialize();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /** @param {import('@theme/events').VariantUpdateEvent} event */
  #handleVariantUpdate = (event) => {
    const variantId = event.detail.resource?.id;
    if (!variantId) return; // geen variant geselecteerd → laat huidige staan
    this.#show(variantId);
  };

  #initialize() {
    // Prioriteit: ?variant= in de URL → data-attribuut → productform → eerste blok
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return this.#show(urlVariant);

    if (this.dataset.initialVariantId) return this.#show(this.dataset.initialVariantId);

    const variantIdInput = this.closest('product-form')?.querySelector('[ref="variantId"]');
    if (variantIdInput?.value) return this.#show(variantIdInput.value);

    const first = this.#variantBlocks()[0];
    if (first) this.#show(first.dataset.variantId);
  }

  /**
   * Altijd live queryen, nooit cachen: na een combined-listing-morph kan de set
   * variant-divs gewijzigd zijn terwijl dit element zelf hergebruikt is.
   * @returns {HTMLElement[]}
   */
  #variantBlocks() {
    return Array.from(this.querySelectorAll('.bezorg-retour__variant'));
  }

  /** @param {string} variantId */
  #show(variantId) {
    const id = String(variantId);
    this.#variantBlocks().forEach((el) => {
      el.hidden = el.dataset.variantId !== id;
    });
  }
}

if (!customElements.get('bezorg-retour')) customElements.define('bezorg-retour', BezorgRetour);
